/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-kno2
 * Kno2 Document Fetcher API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Kno2Info } from './Kno2Info';
import {
    Kno2InfoFromJSON,
    Kno2InfoFromJSONTyped,
    Kno2InfoToJSON,
} from './Kno2Info';

/**
 * 
 * @export
 * @interface GetKno2Info200Response
 */
export interface GetKno2Info200Response {
    /**
     * 
     * @type {Kno2Info}
     * @memberof GetKno2Info200Response
     */
    data?: Kno2Info;
}

/**
 * Check if a given object implements the GetKno2Info200Response interface.
 */
export function instanceOfGetKno2Info200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetKno2Info200ResponseFromJSON(json: any): GetKno2Info200Response {
    return GetKno2Info200ResponseFromJSONTyped(json, false);
}

export function GetKno2Info200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetKno2Info200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : Kno2InfoFromJSON(json['data']),
    };
}

export function GetKno2Info200ResponseToJSON(value?: GetKno2Info200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': Kno2InfoToJSON(value.data),
    };
}

